<template>
  <div>
    <PriceImportPanel />
    <PriceBatchAudit />
    <ManualDiscountPanel />
  </div>
</template>

<script>
import PriceImportPanel from "./PriceImportPanel.vue";
import PriceBatchAudit from "./PriceBatchAudit.vue";
import ManualDiscountPanel from "./ManualDiscountPanel.vue";

export default {
  name: "CmimetTab",
  components: { PriceImportPanel, PriceBatchAudit, ManualDiscountPanel },
  inject: ["po"],
};
</script>
